import { Link } from 'react-router-dom';
import { aboutData } from '@/mocks/about';

export default function BrandStats() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-0">
          <div className="lg:w-1/2">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-900 leading-tight">
              百万网址导航
              <br />
              千万用户信赖
              <br />
              八年品质沉淀
            </h2>
            <div className="mt-10 grid grid-cols-3 gap-0 divide-x divide-foreground-200">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="px-4 first:pl-0 last:pr-0">
                  <p className="font-label font-bold text-3xl md:text-4xl text-primary-500">
                    {stat.value}
                  </p>
                  <p className="mt-2 text-foreground-500 text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-label font-medium text-sm cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-1/2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md aspect-square bg-accent-100 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20soft%20pastel%20pink%20and%20coral%20rounded%20shapes%20overlapping%20in%20minimal%20style%2C%20clean%20and%20airy%20design%2C%20subtle%20gradients%2C%20modern%20tech%20brand%20aesthetic%2C%20smooth%20organic%20shapes%2C%20no%20text%2C%20light%20background&width=800&height=800&seq=brand-stats-51nav&orientation=squarish"
                alt="51网址导航品牌视觉"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}